var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgColumnsIconCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_26092",
    "data-name": "Group 26092",
    transform: "translate(-177 -411)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25460",
    "data-name": "Group 25460",
    transform: "translate(-1079 -708)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1564",
    "data-name": "Ellipse 1564",
    cx: 11.5,
    cy: 11.5,
    r: 11.5,
    transform: "translate(1256 1119)",
    fill: "#b5b5b5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_25462",
    "data-name": "Group 25462",
    transform: "translate(-524.359 -617.95)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7381",
    "data-name": "Path 7381",
    d: "M708.994,1035.95a.636.636,0,0,0-.634.635v4.952h0v1.126h0v1.237a.635.635,0,0,0,1.271,0v-4.952h0v-1.127h0v-1.236A.636.636,0,0,0,708.994,1035.95Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7382",
    "data-name": "Path 7382",
    d: "M713.016,1035.95a.636.636,0,0,0-.634.635v4.952h0v1.126h0v1.237a.635.635,0,0,0,1.271,0v-4.952h0v-1.127h0v-1.236A.637.637,0,0,0,713.016,1035.95Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7383",
    "data-name": "Path 7383",
    d: "M717.053,1035.95a.636.636,0,0,0-.634.635v4.952h0v1.126h0v1.237a.635.635,0,0,0,1.271,0v-4.952h0v-1.127h0v-1.236A.637.637,0,0,0,717.053,1035.95Z",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgColumnsIconCircle);
export default __webpack_public_path__ + "static/media/columns-icon_circle.4515c1f73140be46d73b80c182ccae48.svg";
export { ForwardRef as ReactComponent };